export default "__VITE_ASSET__BRHsIB4f__"